<template>
  <v-flex>
    <!-- <v-spacer></v-spacer> -->
    <bar-chart
      :chart-data="favoriteDrillStats"
      :options="options"
      :styles="barChartStyles"
      title="Groups"
    ></bar-chart>
  </v-flex>
</template>

<script>
import { mapGetters } from "vuex";
import BarChart from "../../constants/BarChart.js";

export default {
  components: {
    BarChart
  },
  data() {
    return {
      options: null,
      favoriteDrillStats: null
    };
  },
  computed: {
    ...mapGetters(["loading", "error", "clubInfo"]),
    barChartStyles() {
      return {
        position: "relative",
        height: "34.5vh"
      };
    }
  },
  created() {
    this.fillData();
  },
  methods: {
    rgba(r, g, b, a) {
      return ["rgba(", r, ",", g, ",", b, ",", a, ")"].join("");
    },
    fillData() {
      this.favoriteDrillStats = {
        labels: this.clubInfo.edges[0].node.team.edges.reduce(function(
          accumulator,
          currentValue
        ) {
          return [...accumulator, currentValue.node.teamName];
        },
        []),
        datasets: [
          {
            label: "Likes #",
            data: this.clubInfo.edges[0].node.team.edges.reduce(function(
              accumulator,
              currentValue
            ) {
              return [...accumulator, currentValue.node.athlete.edges.length];
            },
            []),
            backgroundColor: [
              "rgba(255, 99, 132, 0.2)",
              "rgba(54, 162, 235, 0.2)",
              "rgba(255, 206, 86, 0.2)",
              "rgba(75, 192, 192, 0.2)",
              "rgba(153, 102, 255, 0.2)",
              "rgba(255, 159, 64, 0.2)",
              "rgba(255, 99, 132, 0.2)",
              "rgba(54, 162, 235, 0.2)",
              "rgba(255, 206, 86, 0.2)",
              "rgba(75, 192, 192, 0.2)",
              "rgba(153, 102, 255, 0.2)",
              "rgba(255, 159, 64, 0.2)"
            ],
            borderColor: [
              "rgba(255,99,132,1)",
              "rgba(54, 162, 235, 1)",
              "rgba(255, 206, 86, 1)",
              "rgba(75, 192, 192, 1)",
              "rgba(153, 102, 255, 1)",
              "rgba(255, 159, 64, 1)",
              "rgba(255,99,132,1)",
              "rgba(54, 162, 235, 1)",
              "rgba(255, 206, 86, 1)",
              "rgba(75, 192, 192, 1)",
              "rgba(153, 102, 255, 1)",
              "rgba(255, 159, 64, 1)"
            ],
            borderWidth: 1
          }
        ]
      };
    }
  },

  mounted() {
    // console.log(this.clubInfo);
    setTimeout(() => {
      console.log(this.clubInfo);
    }, 5000);
    // if (!this.favoriteDrillStats) {
    //   setInterval(this.fillData, 2000);
    // }
  }
};
</script>

<style>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
